"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var PlayNotebook = function PlayNotebook(props) {
  var isPlayingNotebook = props.isPlayingNotebook,
    onPlayNotebook = props.onPlayNotebook;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "play-notebook-holder"
  }, /*#__PURE__*/_react.default.createElement("button", {
    "data-test-id": "play-notebook",
    type: "button",
    className: (0, _classnames.default)('play-notebook', {
      loading: isPlayingNotebook
    }),
    onClick: onPlayNotebook
  }, /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/_react.default.createElement("polygon", {
    points: "8,6 14,10 8,14"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "9",
    strokeWidth: "2",
    fill: "transparent"
  })), /*#__PURE__*/_react.default.createElement("span", null, isPlayingNotebook ? 'Playing Notebook ...' : 'Play Notebook')));
};
var _default = exports.default = PlayNotebook;
//# sourceMappingURL=PlayNotebook.js.map